export { default, floatingToolbarPlugin } from './FloatingToolbar';